export default __webpack_public_path__ + "static/media/christmasLogo.8a3098ea.png";